import { lazy } from 'react';

// MealPlan - Primary destination after login
// Lazy loaded but aggressively prefetched during login/signup
// Contains @mui/x-date-pickers which is ~100-200KB

export const MealPlan = lazy(() => import(
  /* webpackChunkName: "mealplan" */ '../../pages/MealPlan'
));
